import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import MaterialTableTS from "components/tables/MaterialTableTS";
import DownloadButton from "../../../../components/DownloadButton";
import { useGetFranchiseeEmployees } from "./api/useGetFranchiseeEmployees";

type DynamicRow = Record<string, any>;

export const FranchiseeEmployees = () => {
  const { data: franchiseeEmployees, isLoading: franchiseeEmployeesLoading } =
    useGetFranchiseeEmployees();

  //Format Date
  function formatDate(date) {
    const d = new Date(date);

    if (Number.isNaN(d.getTime())) return "";

    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }

  //For downloading table data
  const exportdata = franchiseeEmployees?.map((row: DynamicRow) => {
    const formattedRow: Record<string, any> = {};
    Object.entries(row).forEach(([key, value]) => {
      if (key.toLowerCase().includes("date") && value) {
        formattedRow[key] = formatDate(value);
      } else {
        formattedRow[key] = value;
      }
    });
    return formattedRow;
  });

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "FranchiseeEmployeesReport_" + dateTimeToday + ".csv",
    data: exportdata ?? [],
  };

  const employeeColumns =
    franchiseeEmployees && franchiseeEmployees.length > 0
      ? Object.keys(franchiseeEmployees[0]).map((key) => ({
          title: key
            .replaceAll(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase()),
          field: key,
          render: (row: any) => {
            const value = row[key];

            if (value === null || value === undefined) return "";

            // Format dates
            if (key.toLowerCase().includes("date")) {
              try {
                return formatDate(value);
              } catch {
                return String(value);
              }
            }

            // Convert objects or arrays to JSON strings
            if (typeof value === "object") {
              return JSON.stringify(value);
            }

            return value !== null && value !== undefined ? String(value) : "";
          },
        }))
      : [];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: All Franchisee Employees Data
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Franchisee Employees
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-1 mr-1">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {franchiseeEmployees?.length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={franchiseeEmployees}
            isLoading={franchiseeEmployeesLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
